import { useTranslation } from "react-i18next";
import AmerModal from "components/shared/amer-modal";
import ModalActions from "components/shared/ModalActions";
import PrimaryButton from "components/shared/PrimaryButton";
import LtrText from "components/shared/LtrText";
import useIdleLogout from "hooks/useIdleLogout";
import { MODAL_SIZE } from "constants/ui";

const formatCountdown = (seconds) =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;

const IdleLogoutModal = () => {
  const { t } = useTranslation();
  const { isWarningOpen, secondsLeft, stayLoggedIn, logoutNow } =
    useIdleLogout();

  return (
    <AmerModal
      isOpen={isWarningOpen}
      handleCancel={stayLoggedIn}
      size={MODAL_SIZE.SMALL}
      title={t("idleLogout.title")}
      footer={
        <ModalActions
          onCancel={logoutNow}
          cancelLabel={t("idleLogout.logoutNow")}
        >
          <PrimaryButton onClick={stayLoggedIn}>
            {t("idleLogout.stayLoggedIn")}
          </PrimaryButton>
        </ModalActions>
      }
    >
      <div className="flex flex-col items-center gap-3 py-2 text-center">
        <p className="text-sm text-text-body">{t("idleLogout.message")}</p>
        <LtrText className="text-3xl font-bold tabular-nums text-danger">
          {formatCountdown(secondsLeft ?? 0)}
        </LtrText>
      </div>
    </AmerModal>
  );
};

export default IdleLogoutModal;
